<div class="referrals">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mr-auto">
      <li class="breadcrumb-item" aria-current="page">Usage</li>
      <li class="breadcrumb-item active"><a [routerLink]="url">{{label|titlecase}}</a></li>
    </ol>
  </nav>
  <hr>
  <router-outlet></router-outlet>
  <app-usage-table></app-usage-table>
</div>
